// Where the student is right now, for an assignment submission. The backend
// rejects a student's submission without one (LOCATION_REQUIRED), as the
// Western app has always required.
const REASONS = { 1: 'denied', 2: 'unavailable', 3: 'timeout' };

// Rejects with an Error whose `reason` is denied | unavailable | timeout |
// unsupported, so the caller can tell the student what to fix.
export function getCurrentLocation(geolocation = typeof navigator !== 'undefined' ? navigator.geolocation : undefined) {
  return new Promise((resolve, reject) => {
    const fail = (reason) => reject(Object.assign(new Error(`location ${reason}`), { reason }));
    if (!geolocation) {
      fail('unsupported');
      return;
    }
    geolocation.getCurrentPosition(
      ({ coords }) => resolve({ latitude: String(coords.latitude), longitude: String(coords.longitude) }),
      (err) => fail(REASONS[err && err.code] || 'unavailable'),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
    );
  });
}

// Which "how to turn location back on" steps to show. A web page cannot
// re-prompt once the student blocked it, nor open the browser's settings.
export function locationHelpPlatform(
  userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '',
  maxTouchPoints = typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 0,
) {
  const ua = userAgent || '';
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  if (/Macintosh/.test(ua)) {
    // iPadOS sends a Mac user agent; only touch support tells them apart.
    if (maxTouchPoints > 1) return 'ios';
    if (/Chrome\//.test(ua)) return 'mac-chrome';
    if (/Version\/[\d.]+ Safari/.test(ua)) return 'mac-safari';
    return 'other';
  }
  if (/Windows/.test(ua)) return 'windows';
  return 'other';
}
